<template>
  <div>
    <div class="operationControl">
      <div class="searchbox">
        <div title="课程名称" class="searchboxItem ci-full">
          <span class="itemLabel">课程名称:</span>
          <el-input v-model="searchName" type="text" clearable size="small" placeholder="请输入课程名称" />
        </div>
        <!-- <div title="培训类型" class="searchboxItem ci-full flexcc">
            <span class="itemLabel">培训类型:</span>
            <tree
              ref="tree"
              @eventBtn="childBack"
              :ruleForm="ruleForm"
              size="small"
              @clearParams="clearParams"
              modal
              typeStu
            />
          </div>
          <div title="资源提供者" class="searchboxItem ci-full">
            <span class="itemLabel">资源提供者:</span>
            <el-select
              size="small"
              v-model="compId"
              remote
              :remote-method="getCompanyList"
              filterable
              clearable
              placeholder="请至少输入两个字搜索"
            >
              <el-option
                v-for="item in CompanyList"
                :key="item.compId"
                :label="item.compName"
                :value="item.compId"
              ></el-option>
            </el-select>
          </div> -->
        <div class="df">
          <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
        </div>
      </div>
      <div class="df searchbox">
        <!-- <el-button type="primary" class="bgc-bv" round @click="doRoute">我要发布</el-button>  -->
      </div>
    </div>
    <div class="framePage-scroll">
      <div class="ovy-a">
        <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
          style="width: 100%" stripe :header-cell-style="tableHeader">
          <el-table-column label="序号" align="center" type="index" fixed :index="indexMethod" />
          <el-table-column label="课程名称" width="200" align="center" prop="courseName" fixed />

          <el-table-column label="总学时" prop="totalLessonNum" show-overflow-tooltip align="center" />
<!--          <el-table-column label="总学时" prop="lessonNum" show-overflow-tooltip align="right" />-->
          <el-table-column label="课件数量" prop="kpointTotalNum" show-overflow-tooltip align="center" />
          <el-table-column label="视频总时长" minWidth="120" prop="kpointTotalDurationStr" show-overflow-tooltip align="center" />
          <el-table-column label="培训类型" align="center" show-overflow-tooltip prop="trainTypeNamePath"  />
          <el-table-column label="操作" align="center" width="100px" fixed="right">
            <div slot-scope="scope">
              <!-- <el-button type="text" style="padding: 0 5px" size="mini" @click="seeCourse(scope.row)">详情</el-button> -->
              <el-button style="padding: 0 5px" :disabled="scope.row.isPull" type="text"
                size="mini" @click="salesState(scope.row.courseId)">拉取课程</el-button>
            </div>
          </el-table-column>
          <Empty slot="empty" />
        </el-table>
      </div>
    </div>
    <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import tree from "@/components/treePopup";
export default {
  name: "platform_Course",
  components: {
    Empty,
    PageNum,
    tree,
  },
  mixins: [List],
  data() {
    return {
      CompanyList: [], // 资源提供者
      activeName: "first",
      searchName: "",
      trainTypeId: "", // 培训类型
      compId: "", // 资源提供者
      props: {
        value: "id",
        label: "label",
        emitPath: false,
      },
      // 培训类型 - 数据
      params: {},
      ruleForm: {
        Trainingtype: "",
      },
    };
  },
  watch: {
    compId: function (val) {
      if (val == "") {
        this.CompanyList = [];
      }
    },
  },
  created() { },
  computed: {},
  methods: {
    // 培训类型回调
    childBack(params) {
      this.params = { ...params };
    },
    clearParams() {
      this.params = {};
    },

    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        KEYWORDS: this.searchName || "",
        // compId: this.compId || "",
      };
      if (this.params.trainFormId) {
        params.trainTypeId = this.params.trainFormId;
      }
      if (this.params.levelFormId) {
        params.trainLevelId = this.params.levelFormId;
      }
      if (this.params.occFormId) {
        params.occupationId = this.params.occFormId;
      }
      if (this.params.postFormId) {
        params.postId = this.params.postFormId;
      }
      if (this.params.industryFormId) {
        params.industryId = this.params.industryFormId;
      }
      this.doFetch({
        url: "/biz/qa/QaCourse/pullQaListPage",
        params,
        pageNum,
      });
    },
    seeCourse(row) {
      this.$router.push({
        path: "/web/coursePages",
        query: {
          courseId: row.courseId,
          addState: row.addState,
          notState: row.notState,
        },
      });
    },
    // 资源提供者
    getCompanyList(query) {
      if (query.trim().length >= 2) {
        this.$post("/sys/company/queryCompanyList", { compName: query })
          .then((res) => {
            if (res.status == 0) {
              this.CompanyList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.CompanyList = [];
      }
    },
    // 拉取课程
    salesState(courseId) {
      this.$post("/biz/qa/QaCourse/pullQaCourse", {
        courseId,
      })
        .then((res) => {
          if (res.status == 0) {
            this.$message({
              type: "success",
              message: "已成功加入我的课程",
            });
            this.getData(this.pageNum);
          }
        })
        .catch(() => {
          return;
        });
    },
    // 我要发布
    doRoute() {
      this.$router.push({
        path: "/web/myresourseList",
        query: {
          active: "first",
        },
      });
    },
    getTableHeight(opDom = true, page = true) {
      let tHeight =
        window.innerHeight - (3 + 1.35 + 3.25 + 0.675 + 2 + 1.35) * 16;
      if (opDom) {
        tHeight -= 40 + 0.675 * 16 + 1 + 40 + 15;
      }
      if (page) {
        tHeight -= 32;
      }
      this.tableHeight = tHeight;
    },
    getTime(val) {
      if (!val) {
        return "0秒";
      }
      let h = parseInt(val / 60 / 60);
      let m = parseInt((val % 3600) / 60);
      let s = (val % 60).toFixed(2);
      if (h < 9) {
        h = "0" + h;
      }
      if (m < 9) {
        m = "0" + m;
      }
      if (s < 9) {
        s = "0" + s;
      }
      return (
        (h != "00" ? h + "时" : "") +
        (m != "00" ? m + "分" : "") +
        (s != "00" ? s + "秒" : "") || ""
      );
    },
  },
};
</script>
<style lang="less" scoped></style>